import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import { CardContainer } from '../Reusable/CardContainer'
import { Flex, FlexColumn } from '../../Reusable/Container'
import BusinessLogo from '../../Reusable/BusinessLogo'
import { Text } from '../../Reusable/Text'
import { getDateInLocalTZ, getGreeting, getUserApps, toCurrency } from '../../../Utils/util'
import moment from 'moment'
import hexToRgba from 'hex-to-rgba'
import { Divider } from '../../Reusable/Input'
import { apiGET, trackEvent } from '../../../Utils/api'
import CardHeader from '../Reusable/CardHeader'
import FormattedIcon from '../Reusable/FormattedIcon'
import AppIcon from '../../../Images/product-menu/credit-menu-icon-active.png'
import LucideIcon, { Button, TextButton } from '../../Reusable/Button'
import ArrowRight from "../../../Images/arrow-right.png"
import { Image } from '../../Reusable/Image'

import { Clock, TrendingUp } from 'lucide-react'
import { creditARAdvances, creditAvailableFunds } from '../Utils/EmptyStateData'
import OverlayContainer from '../Reusable/OverlayContainer'
import { LoadingOutlined } from '@ant-design/icons'

class CreditFunds extends Component {
    state = {
        loading: true,
        arAdvances: [],
        emptyStateCard: false,
        emptyStateData: {
            availableFunds: creditAvailableFunds,
            arAdvances: creditARAdvances.ARAdvances
        }
    }

    componentDidMount() {
        var { store } = this.props
        const allowedApps = getUserApps(store)
        const arCreditApp = allowedApps.includes("ARCredit")
        const ablCreditApp = allowedApps.includes("ABLCredit")
        const tlCreditApp = allowedApps.includes("TermLoans")
        var Attributes = store.Attributes || {};
        const businessAttributes = Attributes.Businesses || {};

        const creditEnabled = (arCreditApp || ablCreditApp || tlCreditApp)
        if(!creditEnabled) {
            this.setState({ emptyStateCard: true, loading: false })
        } else {
            if (businessAttributes.InventoryLOCEnabled) {
                this.fetchInventoryAdvanceData()
            } else if (arCreditApp) {
                this.fetchARAdvanceData()
                this.fetchAdvances()
            } else if (ablCreditApp) {
                this.fetchABLAdvanceData()
                this.fetchAdvances()
            } else if (tlCreditApp) {
                this.fetchTermLoanAdvances()
            } else {
                this.setState({ emptyStateCard: true })
            }            
        }        
    }

    fetchARAdvanceData = () => {
        const headers = {
            businesskey: this.props.store.BusinessUniqueKey
        }

        apiGET("/arfinancing/funds/view", headers, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp.data
                console.log("/arfinancing/funds/view", JSON.stringify(data))
                this.setState({ availableFunds: data, arCreditApp: true })
            } catch (error) {
                console.log("ERRR", error.stack)
            }
        })
    }

    fetchABLAdvanceData = () => {
        const headers = {
            businesskey: this.props.store.BusinessUniqueKey
        }

        apiGET("/assetbasedloan/funds/view", headers, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp.data
                console.log("/arfinancing/funds/view", JSON.stringify(data))
                this.setState({ availableFunds: data, ablCreditApp: true })
            } catch (error) {
                console.log("ERRR", error.stack)
            }
        })
    }

    fetchAdvances() {
        const headers = {
            businesskey: this.props.store.BusinessUniqueKey
        }

        apiGET("/financing/advances/view", headers, (err, resp) => {
            try {
                const data = resp.data || {}
                this.setState({ arAdvances: data.ARAdvances || [] })
            } catch (error) {
                console.log("ERRR", error.stack)
            }
        })
    }

    fetchTermLoanAdvances() {
        const headers = {
            businesskey: this.props.store.BusinessUniqueKey
        }
        apiGET("/gnpl/funding/draws", headers, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp.data
                this.setState({ tlAdvances: data.Advances, tlAdvanceInfo: data.AdvanceInfo, tlCreditApp: true })
            } catch (error) {
                console.log("ERRR", error.stack)
            }
        })
    }

    fetchInventoryAdvanceData = () => {
        const headers = {
            businesskey: this.props.store.BusinessUniqueKey
        }

        apiGET("/inventoryfinancing/funds/view", headers, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp.data
                console.log("/inventoryfinancing/funds/view", JSON.stringify(data))
                this.setState({ availableFunds: data, arCreditApp: true })
            } catch (error) {
                console.log("ERRR", error.stack)
            }
        })
    }

    render() {
        const { theme, store } =  this.props
        const { UAM } = store
        var { availableFunds, arAdvances, ablCreditApp, tlAdvanceInfo, tlAdvances, emptyStateCard, emptyStateData, arCreditApp, tlCreditApp, loading } = this.state
        var { AvailableFunds, BorrowerAdvanceLimit, BorrowerAdvanceTaken, OverAdvanced } = availableFunds || {}
        var Attributes = store.Attributes || {};
        const businessAttributes = Attributes.Businesses || {};

        var ctaPath = 'credit/ar-credit/advances'
        var advanceCta = '/credit/ar-credit/advances/request'
        if(!emptyStateCard) { 
            if(tlCreditApp) {
                tlAdvanceInfo = tlAdvanceInfo || {}
                AvailableFunds = tlAdvanceInfo.CreditLeft
                BorrowerAdvanceTaken = tlAdvanceInfo.CreditTaken
                arAdvances = tlAdvances
                ctaPath = 'credit/term-loans/advances'
                advanceCta = ctaPath //'/credit/term-loans/advances/request'
            }

            if(ablCreditApp) {
                var ctaPath = 'credit/abl-credit/advances'
                var advanceCta = 'credit/abl-credit/advances'
            }

            if(businessAttributes.InventoryLOCEnabled){
                var ctaPath = '/credit/inventory-loc/advances'
                var advanceCta = 'credit/inventory-loc/advances'
            }
            
            return (
                <CardContainer small>
                    <FlexColumn>
                        <CardHeader 
                            imgSrc={AppIcon}
                            titleText='Credit' 
                            desc='Overview'
                            path={ctaPath}
                        />
                        {
                            loading ?
                            <LoadingOutlined style={{ fontSize: 18, marginTop: 40 }} spin />
                            :
                            <FlexColumn style={{ padding: "20px 40px" }} gap='12px'>
                                <FlexColumn gap='8px'>
                                    <Text size='24px' weight={600}>${toCurrency(AvailableFunds)}</Text>
                                    <Text lightText size='16px'>Available funds</Text>
                                    <TextButton disabled={OverAdvanced || UAM.aionCustomerSupportUser || UAM.aionUnderWriterUser} permtype="ARCredit.Advances" 
                                        onClick={() => {
                                            trackEvent({ name: "dashboard_cta", property: `request funds` });
                                            this.props.history.push(advanceCta);
                                        }} 
                                        text='REQUEST FUNDS' rightIcon={<Image src={ArrowRight} />} 
                                    />
                                </FlexColumn>
                                {
                                    BorrowerAdvanceLimit &&
                                    <>
                                        <Divider />
                                        <FlexColumn gap='8px'>
                                            <Text size='20px' weight={600}>${toCurrency(BorrowerAdvanceLimit)}</Text>
                                            <Text lightText size='16px'>Limit</Text>
                                        </FlexColumn>
                                    </>
                                }
                                
                                <Divider />
                                <Flex between gap='16px'>
                                    {
                                        !ablCreditApp &&
                                        <FlexColumn gap='8px'>
                                            <Text size='20px' weight={600}>${toCurrency(BorrowerAdvanceTaken)}</Text>
                                            <Text lightText size='16px'>Outstanding principal</Text>
                                        </FlexColumn>
                                    }
                                    {
                                        (arAdvances || []).length > 0 &&
                                        <FlexColumn gap='8px'>
                                            <Text size='20px' weight={600}>${toCurrency(arAdvances[arAdvances.length-1].AdvanceAmount)}</Text>
                                            <Flex start centerHorizontally gap='4px'>
                                                <FormattedIcon icon={Clock} size={15} /> 
                                                <Text lightText size='16px'>Recent draw</Text>
                                            </Flex>
                                        </FlexColumn>
                                    }
                                </Flex>
                                
                            </FlexColumn>
                        }
                        
                    </FlexColumn>
                </CardContainer>
            )
        }
        
        else
            return (
                <CardContainer small>
                    <OverlayContainer
                        // fadeDirection="bottom"
                        small
                        radial
                        message={
                            <FlexColumn center gap='8px'>
                                <LucideIcon icon={TrendingUp} color={theme.colors.primary} size={24} />
                                <Text heading weight={600}>Grow with flexible financing</Text>
                                <Text center>Unrestricted, non-dilutive capital. The cash you need, when & where you need it.</Text>
                                {/* <Text center color={theme.colors.primary2}>Reach us at contact@aionfi.com</Text> */}
                            </FlexColumn>
                        }
                    >
                        <FlexColumn start grow>
                            <CardHeader 
                                imgSrc={AppIcon}
                                titleText='Credit' 
                                desc='Overview'
                                path='credit/ar-credit/advances'
                            />
                            <FlexColumn style={{ padding: "20px 40px" }} gap='12px'>
                                <FlexColumn gap='8px'>
                                    <Text size='24px' weight={600}>${toCurrency(emptyStateData.availableFunds.AvailableFunds)}</Text>
                                    <Text lightText size='16px'>Available funds</Text>
                                    <TextButton permtype="ARCredit.Advances" onClick={() => {
                                        trackEvent({ name: "dashboard_cta", property: `request funds` });
                                        this.props.history.push('/credit/ar-credit/advances/request')
                                    }} text='REQUEST FUNDS' rightIcon={<Image src={ArrowRight} />} />
                                </FlexColumn>
                                <Divider />
                                <FlexColumn gap='8px'>
                                    <Text size='20px' weight={600}>${toCurrency(emptyStateData.availableFunds.BorrowerAdvanceLimit)}</Text>
                                    <Text lightText size='16px'>Limit</Text>
                                </FlexColumn>
                                <Divider />
                                <Flex between gap='16px'>
                                    <FlexColumn gap='8px'>
                                        <Text size='20px' weight={600}>${toCurrency(emptyStateData.availableFunds.BorrowerAdvanceTaken)}</Text>
                                        <Text lightText size='16px'>Outstanding principal</Text>
                                    </FlexColumn>
                                    {
                                        (emptyStateData.arAdvances || []).length > 0 &&
                                        <FlexColumn gap='8px'>
                                            <Text size='20px' weight={600}>${toCurrency(emptyStateData.arAdvances[emptyStateData.arAdvances.length-1].AdvanceAmount)}</Text>
                                            <Flex start centerHorizontally gap='4px'>
                                                <FormattedIcon icon={Clock} size={15} /> 
                                                <Text lightText size='16px'>Recent draw</Text>
                                            </Flex>
                                        </FlexColumn>
                                    }
                                </Flex>
                                
                            </FlexColumn>
                        </FlexColumn>
                    </OverlayContainer>
                </CardContainer>
            )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(CreditFunds)))